import Vue from 'vue'
import pluralizationRules from '@/i18n/rules/pluralization'
import numberFormats from '@/i18n/rules/numbers'
// import dateTimeFormats from '@/i18n/rules/datetime'
import en from '@/i18n/locales/en.json'
import zh from '@/i18n/locales/zh.json'
import ms from '@/i18n/locales/ms.json'
import { LOCALE } from '@/../../config/env'
import nextTick from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const lclMessages = {
  en,
  zh,
  ms
}

const Tr = {
  get defaultLocale() {
    return LOCALE.VITE_DEFAULT_LOCALE
  },

  get supportedLocales() {
    return LOCALE.VITE_SUPPORTED_LOCALES.split(',')
  },

  get currentLocale() {
    return i18n.locale
  },

  set currentLocale(newLocale) {
    i18n.locale = newLocale
  },

  async switchLanguage(newLocale: any) {
    await Tr.loadLocaleMessages(newLocale)
    Tr.currentLocale = newLocale
    const htmlElement = document.querySelector('html') as HTMLElement
    htmlElement.setAttribute('lang', newLocale)
    localStorage.setItem('user-locale', newLocale)
  },

   async loadLocaleMessages(locale: any) {
    if (!i18n.availableLocales.includes(locale)) {
      const messages =  await require(`i18n/locales/${locale}.json`)
      i18n.setLocaleMessage(locale, messages.default)
    }
    return new nextTick()
  },

  isLocaleSupported(locale: string) {
    return Tr.supportedLocales.includes(locale)
  },

  getUserLocale() {
    const locale = window.navigator.language || Tr.defaultLocale
    return {
      locale: locale,
      localeNoRegion: locale.split('-')[0]
    }
  },

  getPersistedLocale() {
    const persistedLocale = localStorage.getItem('user-locale') || ''

    if (Tr.isLocaleSupported(persistedLocale)) {
      return persistedLocale
    } else {
      return null
    }
  },

  guessDefaultLocale() {
    const userPersistedLocale = Tr.getPersistedLocale()
    if (userPersistedLocale) {
      return userPersistedLocale
    }

    const userPreferredLocale = Tr.getUserLocale()

    if (Tr.isLocaleSupported(userPreferredLocale.locale)) {
      return userPreferredLocale.locale
    }

    if (Tr.isLocaleSupported(userPreferredLocale.localeNoRegion)) {
      return userPreferredLocale.localeNoRegion
    }

    return Tr.defaultLocale
  },

  async routeMiddleware(to: any, _from: any, next: any) {
    const paramLocale = to.params.locale

    if (!Tr.isLocaleSupported(paramLocale)) {
      return next(Tr.guessDefaultLocale())
    }

    await Tr.switchLanguage(paramLocale)

    return next()
  },

  i18nRoute(): string {
    return '/'

    // return {
    //   ...to,
    //   params: {
    //     locale: Tr.currentLocale,
    //     ...to.params
    //   }
    // }
  }
}

const i18n = new VueI18n({
  locale:  LOCALE.VITE_DEFAULT_LOCALE, // Tr.guessDefaultLocale(), // Replace with comment  when set to enable localization
  fallbackLocale: LOCALE.VITE_FALLBACK_LOCALE,
  messages: lclMessages,
  pluralizationRules,
  numberFormats
})

export default { Tr, i18n }
